var instagram = function () {
    document.querySelectorAll('.instagram__imagenes').forEach(function (contenedor) {
        var carrusel = contenedor.querySelector('.instagram__carrusel');
        var pista = contenedor.querySelector('.instagram__pista');
        var imagenes = pista
            ? Array.from(pista.querySelectorAll('.instagram__imagen'))
            : [];
        if (!carrusel || !pista || imagenes.length <= 1) {
            return;
        }
        var anterior = document.createElement('button');
        anterior.type = 'button';
        anterior.className = 'instagram__anterior';
        anterior.setAttribute('aria-label', 'Ver la imagen anterior de Instagram');
        anterior.textContent = 'Anterior';
        var siguiente = document.createElement('button');
        siguiente.type = 'button';
        siguiente.className = 'instagram__siguiente';
        siguiente.setAttribute('aria-label', 'Ver la imagen siguiente de Instagram');
        siguiente.textContent = 'Siguiente';
        carrusel.insertBefore(anterior, pista);
        carrusel.appendChild(siguiente);
        var rafId = 0;
        var sincronizaTimeout = 0;
        var posicionObjetivo = 0;
        var actualizaEstado = function () {
            rafId = 0;
            var posiciones = posicionesDeScroll();
            posicionObjetivo = Math.min(posicionObjetivo, posiciones.length - 1);
            anterior.disabled = posicionObjetivo === 0;
            siguiente.disabled = posicionObjetivo === posiciones.length - 1;
            var ocultaNavegacion = anterior.disabled && siguiente.disabled;
            anterior.hidden = ocultaNavegacion;
            siguiente.hidden = ocultaNavegacion;
        };
        var solicitaActualizacion = function () {
            if (!rafId) {
                rafId = requestAnimationFrame(actualizaEstado);
            }
            window.clearTimeout(sincronizaTimeout);
            sincronizaTimeout = window.setTimeout(function () {
                var posiciones = posicionesDeScroll();
                posicionObjetivo = indiceMasCercano(posiciones);
                solicitaActualizacionInmediata();
            }, 150);
        };
        var solicitaActualizacionInmediata = function () {
            if (!rafId) {
                rafId = requestAnimationFrame(actualizaEstado);
            }
        };
        var posicionDeImagen = function (imagen) {
            return imagen.getBoundingClientRect().left
                - pista.getBoundingClientRect().left
                + pista.scrollLeft;
        };
        var posicionesDeScroll = function () {
            var maximo = Math.max(0, pista.scrollWidth - pista.clientWidth);
            var posiciones = [];
            imagenes.forEach(function (imagen) {
                var posicion = Math.min(posicionDeImagen(imagen), maximo);
                if (!posiciones.length || posicion - posiciones[posiciones.length - 1] > 1) {
                    posiciones.push(posicion);
                }
            });
            return posiciones;
        };
        var indiceMasCercano = function (posiciones) {
            var ultimoIndice = posiciones.length - 1;
            if (pista.scrollLeft <= 1) {
                return 0;
            }
            if (pista.scrollLeft >= posiciones[ultimoIndice] - 1) {
                return ultimoIndice;
            }
            var indice = 0;
            var distancia = Number.POSITIVE_INFINITY;
            posiciones.forEach(function (posicion, i) {
                var diferencia = Math.abs(posicion - pista.scrollLeft);
                if (diferencia < distancia) {
                    distancia = diferencia;
                    indice = i;
                }
            });
            return indice;
        };
        var desplaza = function (direccion) {
            var posiciones = posicionesDeScroll();
            var indice = Math.max(0, Math.min(posiciones.length - 1, posicionObjetivo + direccion));
            posicionObjetivo = indice;
            var comportamiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches
                ? 'auto'
                : 'smooth';
            pista.scrollTo({
                left: posiciones[indice],
                behavior: comportamiento
            });
            solicitaActualizacionInmediata();
        };
        var ajusta = function () {
            carrusel.style.position = 'absolute';
            var izquierda = carrusel.getBoundingClientRect().left;
            carrusel.style.width = "".concat(Math.max(0, document.body.offsetWidth - izquierda), "px");
            contenedor.style.height = imagenes.reduce(function (alto, imagen) {
                return Math.max(alto, imagen.offsetHeight);
            }, 0) + 'px';
            solicitaActualizacion();
        };
        anterior.addEventListener('click', function () { return desplaza(-1); });
        siguiente.addEventListener('click', function () { return desplaza(1); });
        pista.addEventListener('scroll', solicitaActualizacion, { passive: true });
        window.addEventListener('resize', ajusta);
        window.addEventListener('load', ajusta, { once: true });
        ajusta();
    });
};
export default instagram;
